<template>
    <ui-modal
        v-show="visible"
        icon="fal fa-user-circle"
        :class="onChangeModal ? 'fac-modal-full' : ''"
        :title="createProposal ? 'Preencher Proposta' : 'Cadastrar Cliente'"
        :load-success="loader.modalSuccess"
        :load="loader.modalLoading"
        :name="name"
        :brl-off="menuList.length > 1"
        :show-close-option="false"
        custom-loader
        @keyup.escape="closeModal"
    >
        <!-- <template #header>
			<ui-menu-card icon="fal fa-cog" icon-size="20">
				<button type="button"
				class="button-old-guia"
				@click="setLink('guia/deal')" >
					Usar Versão Antiga
				</button>
			</ui-menu-card>
		</template> -->

        <template #left>
            <div v-show="menuList.length > 1" class="menu-body">
                <ui-chain-menu v-model="menuList" clickable />
            </div>
        </template>

        <template #custom-loader>
            <ui-loader-message
                :message="loader.message"
                :description="loader.description"
                :loading="loader.modalLoading"
                :success="loader.modalSuccess"
                :failed="loader.modalFailed"
                :close-action="closeModal"
            >
                <template v-if="type === 'launchday'" #complement>
                    <ui-tag-indicator
                        v-if="createdDeal"
                        :color="createdDealStatusColor"
                        :text="createdDeal.id"
                        text-size="12"
                    />
                </template>

                <template #success>
                    <section v-if="type === 'launchday'" class="launch-day">
                        <ui-accreditation-voucher :data="createdDeal" />

                        <ui-button
                            v-if="loader.modalSuccess"
                            design="md primary"
                            @click="printHandler"
                        >
                            Imprimir
                        </ui-button>
                    </section>

                    <section v-else-if="type !== 'simulation'" class="success-actions">
                        <div>
                            <ui-actions-deals-wrapper-list v-model="actionList" />
                        </div>

                        <ui-button
                            v-if="loader.modalSuccess"
                            :disabled="!successAction"
                            design="md primary"
                            @click="successButton"
                        >
                            Avançar
                        </ui-button>
                    </section>
                </template>

                <template #failed>
                    <ui-button
                        v-if="loader.modalFailed"
                        design="md primary"
                        @click="failedActionButton"
                    >
                        Verificar dados e tentar novamente
                    </ui-button>
                </template>
            </ui-loader-message>
        </template>

        <section>
            <div v-show="loader.body" class="loading-area">
                <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
            </div>

            <div v-show="loader.page" class="loading-page">
                <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
            </div>

            <div
                v-show="!loader.body"
                class="body-modal scroll-color"
                :style="{
                    'overflow': viewActive == 'product' ||
                        viewActive == 'responsible' ||
                        viewActive == 'customer' ?
                            'visible' :
                            'auto'
                }"
            >
                <div v-show="viewActive == 'customer'" class="view">
                    <ui-nugget-customer-form
                        ref="clean"
                        v-model="form.customer"
                        :fetch-list.sync="fetchList.customer"
                        :required-fields="customerRequiredField"
                        :observations="customerObservations"
                        :duplicity-config="options.requiredFields"
                        :is-proposal="createProposal"
                        :submit-menu-proposal="jumpStep"
                        nugget-id="create-deal-modal"
                        @handle-change-footer="handleChangeFooter"
                        @handle-full-modal="handleFullModal"
                    />
                </div>

                <div v-show="viewActive == 'product'" class="view">
                    <h3 class="title">Empreendimento de Interesse</h3>
                    <ui-nugget-product-form
                        v-model="form.product"
                        :fetch-list.sync="fetchList.product"
                        :loader-list="loader.product"
                        :required-fileds="productRequiredField"
                        nugget-id="create-deal-modal"
                        only-available-products
                        show-units
                        need-real-product-id
                        :reserve-system="false"
                    />
                </div>

                <div v-show="viewActive == 'status-stage'" class="view">
                    <h3 class="title">Etapa e Status</h3>
                    <ui-nugget-stage-status-form
                        v-model="form.stageStatus"
                        :fetch-list.sync="fetchList.stageStatus"
                        :required-fileds="stageStatusRequiredField"
                        nugget-id="create-deal-modal"
                    />

                    <ui-nugget-historical-form
                        v-model="form.historical"
                        :fetch-list.sync="fetchList.historical"
                        nugget-id="create-deal-modal"
                    />
                </div>

                <div v-show="viewActive == 'responsible'" class="view">
                    <h3 class="title">Responsável</h3>
                    <ui-nugget-responsible-form
                        v-model="form.responsible"
                        :fetch-list.sync="fetchList.responsible"
                        :disable="disableResponsible"
                        nugget-id="create-deal-modal"
                    />
                    <div v-if="disableResponsible" class="warning">
                        A configuração "Aceitar clientes para outros responsáveis" está desativada,
                        não será possível alterar o responsável deste cliente.
                    </div>
                </div>

                <div v-if="createProposal">
                    <div v-for="page in customPage" :key="page.id" class="view">
                        <ui-customs
                            v-if="viewActive == page.tag"
                            :id="idDynamic"
                            :form="nextForm(idDynamic)"
                            :data="page"
                            @input="canSubmitDynamic"
                        />
                    </div>
                </div>
            </div>
        </section>

        <template #footer>
            <div v-if="onChangeFooter">
                <ui-button design="link-alt" @click="comeBack"> Voltar </ui-button>
                <ui-button design="md success" @click="overrideCustomer(customerToUpdate)"> Criar novo negócio </ui-button>
            </div>
            <div v-else class="footer-area">
                <div class="flex-box">
                    <div v-if="duplicityActivated" class="duplicity-warning">
                        <small v-if="duplicityDegree"
                        >Verificação de duplicidade de clientes: {{ duplicityDegree }}
                        </small>
                    </div>
                </div>
                <div class="flex-box">
                    <ui-modal-cancel-button
                        :modal-name="name"
                        design="link-alt"
                        @close="closeModal()"
                    >
                        Cancelar
                    </ui-modal-cancel-button>
                    <ui-button design="md success" :disabled="!canSubmit" @click="handleButton">
                        {{ buttonText }}
                    </ui-button>
                </div>
            </div>
        </template>
        <ui-override-customer-modal name="create-deal-override-customer" />
    </ui-modal>
</template>

<script>
import { uiModal, uiModalCancelButton } from '@/components/ui/modal'
import { uiButton } from '@/components/ui/buttons'
import { uiLoadIndicator } from '@/components/ui'
import { uiLoaderMessage } from '@/components/ui/loader'
import { uiChainMenu } from '@/components/ui/menus'
import {
	uiNuggetCustomerForm,
	uiNuggetStageStatusForm,
	uiNuggetProductForm,
	uiNuggetResponsibleForm,
	uiNuggetHistoricalForm,
} from '@/components/ui-facilita/nuggets'
import { uiActionsDealsWrapperList } from '@/components/ui-facilita/wrapper'
import uiOverrideCustomerModal from './components/override-customer-modal'
import { uiTagIndicator } from '@/components/ui/tags'
import { getProposalGroup } from '@/views/configurations/util/methods'
import uiCustoms from '@/components/ui-facilita/page-customs'
import { uiAccreditationVoucher } from '@/components/ui-facilita/launch'

import { defaultMenuList, defaultActionList } from './data'

import { storage } from '@/services/storage'
import { funnel, deal, dealHistorical, configuration, launchDay } from '@/services/axios'
import {
	utilMixin,
	formMixin,
	alertMixin,
	permissionsMixin,
	loaderMixin,
	helpersMixin,
} from '@/mixins'

import { mapGetters } from 'vuex'

const qs = require('qs')

const defaultDisabled = () => ({})

const defaultForm = () => ({
	customer: {},
	product: {},
	stageStatus: {},
	historical: {},
	responsible: {},
})

const defaultLoader = () => ({
	body: false,
	modalLoading: false,
	modalSuccess: false,
	modalFailed: false,
	page: false,
	message: '',
	description: '',
})

const defaultOptions = () => ({
	requiredFields: null,
	customerDealOwner: null,
})

export default {
	name: 'ui-create-deal-modal',

	components: {
		uiModal,
		uiModalCancelButton,
		uiButton,
		uiLoadIndicator,
		uiLoaderMessage,
		uiChainMenu,
		uiNuggetCustomerForm,
		uiNuggetStageStatusForm,
		uiNuggetProductForm,
		uiNuggetResponsibleForm,
		uiNuggetHistoricalForm,
		uiActionsDealsWrapperList,
		uiOverrideCustomerModal,
		uiTagIndicator,
		uiCustoms,
		uiAccreditationVoucher,
	},

	mixins: [utilMixin, formMixin, alertMixin, permissionsMixin, loaderMixin, helpersMixin],

	props: {
		name: {
			type: String,
			required: true,
		},
		closedOption: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			form: { ...defaultForm() },
			fetchList: { ...defaultForm() },
			disabled: { ...defaultDisabled() },
			loader: { ...defaultLoader() },
			options: { ...defaultOptions() },
			menuList: [],
			actionList: [...defaultActionList()],
			createdCustomer: null,
			createdDeal: null,
			customerToUpdate: null,
			visible: true,
			cantSubmit: false,
			betaFeatures: null,
			type: 'default',
			fromReserveModal: false,
			fromIFrame: false,
			launchProductId: null,
			createProposal: false,
			customPage: [],
			dataProposal: null,
			idDynamic: null,
			dataForm: {},
			isDynamic: false,
			idDeals: null,
			verificationDynamic: false,
			formDynamic: {},
			pageVerifications: {},
			idOverride: null,
			statusOverride: null,
			stageOverride: null,
			idChosen: null,
			statusChosen: null,
			stageChosen: null,
			dataFile: null,
			onChangeModal: false,
			onChangeFooter: false,
			customerId: null,
			proposalSettings: null,
			productInformakon: false,
			hasRequiredFields:false,
			hasConfigurationFields:false
		}
	},

	computed: {
		...mapGetters({
			product: 'simulation/getProduct',
			proposedValue: 'simulation/getProposedValue',
			unity: 'simulation/getUnity',
			user: 'auth/getUser',
			definitions: 'launchDay/getDefinitions'
		}),
		/**
		 * Computed property que verifica qual o item do menu que está ativo.
		 */
		viewActive() {
			const active = this.menuList.find((item) => item.active) || this.menuList[0]
			this.updateIdDynamic(active)
			return active.tag
		},
		successAction() {
			const index = this.actionList.findIndex((action) => action.check == true)
			if (index === -1) return ''
			else return this.actionList[index].action
		},
		isLastStep() {
			const index = this.menuList.findIndex((item) => item.tag === this.viewActive)

			if (index !== -1 && index === this.menuList.length - 1) {
				if (this.viewActive === 'customer-cadastrado') {
					this.updateMenuList([
						{
							id: 1,
							name: 'Cliente Cadastrado',
							tag: 'customer-cadastrado',
							active: true,
							completed: true,
							skiped: false,
							editing: false,
						},
					])
				}
				return true
			}
			return false
		},
		buttonText() {
			return this.isLastStep ? 'Finalizar' : 'Próximo'
		},
		customerValidators() {
			const { name, email, type, mobile, phone, cpf, cnpj, origin_id } = this.form.customer

			const allSubmit = this.customerToUpdate
				? true
				: this.$mx_hasValue(type) &&
				  this.nameValidate(name) &&
				  this.emailValidate(email) &&
				  this.phoneValidate(mobile, 'mobile') &&
				  this.phoneValidate(phone, 'phone') &&
				  (this.cpfValidate(cpf, type) || this.cnpjValidate(cnpj, type)) &&
				  this.hrv(origin_id, 'deal_origin_id')

			return {
				all: allSubmit,
				name: this.$mx_hasValue(name) ? this.nameValidate(name) : true,
				email: this.$mx_hasValue(email) ? this.emailValidate(email) : true,
				mobile: this.$mx_hasValue(mobile) ? this.phoneValidate(mobile, 'mobile') : true,
				phone: this.$mx_hasValue(phone) ? this.phoneValidate(phone, 'phone') : true,
				cpf:
					this.$mx_hasValue(cpf) && type === 'Pessoa Fisica'
						? this.cpfValidate(cpf, type)
						: true,
				cnpj:
					this.$mx_hasValue(cnpj) && type === 'Pessoa Juridica'
						? this.cnpjValidate(cnpj, type)
						: true,
			}
		},
		customerObservations() {
			const cp = this.customerValidators
			return {
				name: !cp.name ? 'Tamanho mínimo 3 caractéres.' : '',
				email: !cp.email ? 'Digite um e-mail válido.' : '',
				mobile: !cp.mobile ? 'Número inválido.' : '',
				phone: !cp.phone ? 'Número inválido.' : '',
				cpf: !cp.cpf ? 'Digite um CPF válido.' : '',
				cnpj: !cp.cnpj ? 'Digite um CNPJ válido.' : '',
			}
		},
		canSubmitStageStatus() {
			const { funnel_stage_id, funnel_stage_status_id } = this.form.stageStatus
			const { status } = this.fetchList.stageStatus
			let r = true
			const needStage = this.requiredField('deal_funnel_stage_id')
			const needStatus = this.requiredField('deal_funnel_stage_status_id')

			if (needStage && needStatus) {
				if (status?.length <= 0) r = this.$mx_hasValue(funnel_stage_id)
				else
					r =
						this.$mx_hasValue(funnel_stage_id) &&
						this.$mx_hasValue(funnel_stage_status_id)
			} else if (needStage && !needStatus) {
				r = this.$mx_hasValue(funnel_stage_id)
			} else if (!needStage && needStatus) {
				r = this.$mx_hasValue(funnel_stage_status_id)
			}

			return r
		},
		canSubmitProduct() {
			const hrv = (v, tag) => this.hasRequiredValue(v, tag)
			if (!this.form.product) return false
			const { real_product } = this.form.product
			return hrv(real_product, 'deal_product_id')
		},
		canSubmitHistorical() {
			const hv = (v) => this.$mx_hasValue(v)
			const { type, message, subject } = this.form.historical
			return !hv(type) || (hv(type) && hv(message) && hv(subject))
		},
		/**
		 * Computed property que valida se os dados do responsável são obrigatórios
		 * Obs.: Atualmente não existem regras que determinam que o responsável e equipe
		 * devem ser informados.
		 */
		canSubmitResponsible() {
			return true
		},
		/**
		 * Computed property que valida os dados dos campos dinâmicos
		 */
		allCanSubmit() {
			const isItemMenu = this.isItemMenu()
			return (
				this.customerValidators.all &&
				(isItemMenu.completed('customer') || this.menuList.length === 1) &&
				this.canSubmitStageStatus &&
				(isItemMenu.completed('stageStatus') || this.isLastStep) &&
				this.canSubmitResponsible
			)
		},
		canSubmit() {
			if (this.isLastStep && this.dataProposal && this.pageVerifications) {
				const allPreviousVerificationsTrue = Object.values(this.pageVerifications).every(
					(value) => value === true
				)
				return allPreviousVerificationsTrue
			}
			if (this.dataProposal && this.verificationDynamic) return true
			if (this.isLastStep && !this.customerToUpdate) return this.allCanSubmit
			if (this.isLastStep && this.customerToUpdate) return true

			switch (this.viewActive) {
				case 'customer':
					if (this.cantSubmit && !this.customerToUpdate) return false
					if (this.cantSubmit && this.customerToUpdate) return true

					return this.customerValidators.all
				case 'product':
					return this.canSubmitProduct
				case 'status-stage':
					return this.canSubmitStageStatus && this.canSubmitHistorical
				case 'responsible':
					return this.canSubmitResponsible
			}

			return false
		},
		/**
		 * Computed property que identifica qual é o tipo de guia para determinar
		 * de onde serão identificados os campos obrigatórios
		 */
		customerValidated() {
			const c = { ...this.form.customer }

			if (this.createProposal) {
				c['guide'] = this.options?.requiredFields?.proposal?.required?.length ?  'proposal' : 'default'
			} else if (this.fromReserveModal) {
				c['guide'] = this.options?.requiredFields?.reserve?.required?.length ? 'reserve' : 'customer'
			} else {
				c['guide'] = 'customer'
			}

			const { team_id, manager_id, broker_id } = this.form.responsible

			if (team_id) c['team_id'] = team_id
			if (manager_id) c['manager_id'] = manager_id
			if (broker_id) c['broker_id'] = broker_id

			delete c.origin_id

			return c
		},
		responsibleValidated() {
			if (this.disableResponsible) {
				return {
					team_id: this.customerToUpdate.owners.team_id,
					broker_id: this.customerToUpdate.owners.broker_id,
					manager_id: this.customerToUpdate.owners.manager_id,
				}
			}
			const { team_id, broker_id, manager_id } = this.form.responsible
			if (this.$mx_userIsBroker)
				return {
					team_id: this.user.team.team_id,
					broker_id: this.user.broker_id,
					manager_id: this.user.manager.manager_id,
				}
			if (this.canSubmitResponsible && this.$mx_hasValue(team_id))
				return { team_id, broker_id, manager_id }
			return {}
		},
		stageStatusValidated() {
			const { funnel_stage_id, funnel_stage_status_id } = this.form.stageStatus
			if (this.canSubmitStageStatus && this.$mx_hasValue(funnel_stage_id))
				return { funnel_stage_id, funnel_stage_status_id }
			return {}
		},
		customerRequiredField() {
			const validation = (field, requiredObject) => {
				const obj = requiredObject
				switch (field) {
					case 'name':
						obj.name = true
						break
					case 'email':
						obj.email = true
						break
					case 'mobile':
						obj.mobile = true
						break
					case 'phone':
						obj.phone = true
						break
					case 'cpf':
						obj.cpf = true
						obj.cnpj = true
						break
					// TODO: foi alterado para mandar para o banco de dados deal_origin_id 
					// e o case origin vai ficar ate que seja feita a alteração no banco também 
					// de origin para deal_origin_id 
					case 'origin':
					case 'deal_origin_id':
						obj.origin = true
				}
				return obj
			}
			return this.requiredFieldLoop(validation)
		},
		productRequiredField() {
			const validation = (field, requiredObject) => {
				const obj = requiredObject
				if (field === 'deal_product_id') obj.product = true
				return obj
			}
			return this.requiredFieldLoop(validation)
		},
		stageStatusRequiredField() {
			const validation = (field, requiredObject) => {
				const obj = requiredObject
				if (field === 'deal_funnel_stage_id') obj.stage = true
				else if (field === 'deal_funnel_stage_status_id') obj.status = true
				return obj
			}
			return this.requiredFieldLoop(validation)
		},
		duplicityDegree() {
			if (!this.options.requiredFields) return undefined

			return this.options.requiredFields.compare == 'or' ? 'Forte' : 'Média'
		},
		ownerDuplicate() {
			if (!this.options.customerDealOwner) return undefined

			return this.options.customerDealOwner.ownerDuplicate == 'active' ? true : false
		},
		duplicityActivated() {
			if (!this.options.requiredFields) return undefined

			return this.options.requiredFields.status == 'active'
		},
		disableResponsible() {
			return !this.ownerDuplicate && this.customerToUpdate && this.duplicityActivated
				? true
				: false
		},
		isDynamicUser() {
			return this.user && this.user.isDynamicGroup ? true : false
		},
		openSearchAllowed() {
			return (
				(this.betaFeatures &&
					this.betaFeatures.opensearch &&
					this.betaFeatures.opensearch[this.user.user_group]) == 1 ||
				(this.isDynamicUser && this.betaFeatures.opensearch['dynamic'] == 1)
			)
		},
		createTaskPayload() {
			const user_name = this.user.first_name
			const user_id = this.user.id
			const manager_name =
				this.createdDeal.owners &&
				this.createdDeal.owners.manager &&
				this.createdDeal.owners.manager.user &&
				this.createdDeal.owners.manager.user.first_name
					? this.createdDeal.owners.manager.user.first_name
					: null
			const manager_user_id =
				this.createdDeal.owners &&
				this.createdDeal.owners.manager &&
				this.createdDeal.owners.manager.user &&
				this.createdDeal.owners.manager.user.id
					? this.createdDeal.owners.manager.user.id
					: null
			const broker_name =
				this.createdDeal.owners &&
				this.createdDeal.owners.broker &&
				this.createdDeal.owners.broker.user &&
				this.createdDeal.owners.broker.user.first_name
					? this.createdDeal.owners.broker.user.first_name
					: null
			const broker_user_id =
				this.createdDeal.owners &&
				this.createdDeal.owners.broker &&
				this.createdDeal.owners.broker.user &&
				this.createdDeal.owners.broker.user.id
					? this.createdDeal.owners.broker.user.id
					: null
			const id = this.createdDeal.id ? this.createdDeal.id : null
			const customer_name =
				this.createdDeal.customer && this.createdDeal.customer.name
					? this.createdDeal.customer.name
					: null
			const broker_id =
				this.createdDeal.owners && this.createdDeal.owners.broker_id
					? this.createdDeal.owners.broker_id
					: null
			const manager_id =
				this.createdDeal.owners && this.createdDeal.owners.manager_id
					? this.createdDeal.owners.manager_id
					: null

			return {
				user_name,
				user_id,
				manager_name,
				manager_user_id,
				broker_name,
				broker_user_id,
				id,
				customer_name,
				broker_id,
				manager_id,
			}
		},
		/**
		 * Computed property que define a cor de status a ser mostrada para o negócio/cliente criado
		 */
		createdDealStatusColor() {
			return this.createdDeal && this.createdDeal.idle_color
				? this.createdDeal.idle_color.color
				: ''
		},
		boolOptions() {
			const list = []
			const options = [
				['Sim', 'yes'],
				['Não', 'no'],
			]
			options.forEach((option, index) => {
				list.push({
					id: index,
					label: option[0],
					value: option[1],
				})
			})
			return list
		},
		setForm(id) {
			return this.formDynamic[id]
		},
	},

	created() {
		this.menuList = this.makeMenuList(defaultMenuList())
		this.actionList = [...defaultActionList()]
	},

	mounted() {
		this.$root.$on(
			'modal-open-' + this.name,
			async (params = null, fromReserveModal = false, fromIFrame = false) => {
				this.fromReserveModal = fromReserveModal;
				this.fromIFrame = fromIFrame;
				this.reset();
				this.$mx_setLoader('body', true);

				this.proposalSettings = await this.getConfig('proposalSettings', 'value_long');

				this.parseParams(params);

				const result = await this.handleType(params);

				const { productData, stageStatus } = result;

				this.betaFeatures = JSON.parse(storage.get('beta_features'));
				this.options.requiredFields = await this.getRequiredFields();
				this.options.customerDealOwner = await this.getCustomerDealOwner();

				this.emitInitializationEvents(productData, stageStatus);

				this.$mx_setLoader('body', false);
			}
		);
		//Envia os dados que serão salvos no page-customs e no repeater-inputs
		this.$root.$on('save-dynamic-data-table', (data, dataTable) => {
			if (this.idDeals || this.idOverride || (this.idChosen && this.idDynamic))
				this.saveDynamic(
					this.idDeals || this.idOverride || this.idChosen,
					this.idDynamic,
					data,
					dataTable,
					true
				)
		})
		//Deletar os arquivos do input do tipo file dos campos dinâmicos
		this.$root.$on('delete-dynamic-data-table', (data) => {
			data.url = `/deal/${this.idDeals || this.idOverride || this.idChosen}/group`
			data.id = this.idDynamic
			data.eventSuccess = 'delete-dynamic-success'
			this.$root.$emit('modal-msg-open-delete-dynamic', data)
		})
		this.$root.$on('create-proposal-modal', (has) => {
			this.createProposal = has
		})
		this.$root.$on('create-deal-load-override-customer', async (data) => {
			// Receives the customer selected in the modal
			this.customerToUpdate = data

			// Captures deal infos (only if uses openSearch)
			await this.captureDealInfo()

			// Creates an object with those responsible for the selected customer
			const responsible = {
				team_id: this.customerToUpdate.owners.team_id,
				broker_id: this.customerToUpdate.owners.broker_id,
				manager_id: this.customerToUpdate.owners.manager_id,
			}

			// Updates those responsible in the component
			this.$root.$emit('nugget-responsible-form-create-deal-modal', responsible)
		})

		this.$root.$on('create-deal-clear-override-customer', () => {
			this.createdCustomer = null
			this.createdDeal = null
			this.customerToUpdate = null

			// Clear responsible
			this.$root.$emit('clean--nugget-responsible-form-create-deal-modal')
		})

		this.$root.$on('create-task-custom-close-create-deal', () => {
			this.visible = true
		})

		this.$root.$on('select-reserve-custom-close-create-deal', () => {
			this.visible = true
		})

		this.$root.$on('create-deal-cant-submit', (bool) => {
			this.cantSubmit = bool
		})
		window.addEventListener('keydown', (event) => {
			if (event.keyCode == 27) {
				this.closeModal()
			}
		})
		this.$root.$on('customer-page-opened', (id, stage, status) => {
			this.idOverride = id
			this.stageOverride = stage
			this.statusOverride = status
		})
		this.$root.$on('customer-open-chosen', (id, stage, status) => {
			this.idChosen = id
			this.stageChosen = stage
			this.statusChosen = status
			this.jumpStepChosen()
		})
		this.$root.$on('select-deal-override-customer', (deals) => {
			if (deals && deals.length > 0 && deals[0]._source){
				this.customerToUpdate = deals[0]._source
			}
		})
	},

	beforeDestroy() {
		this.$root.$off('modal-open-' + this.name)
		this.$root.$off('create-deal-load-override-customer')
		this.$root.$off('create-deal-clear-override-customer')
		this.$root.$off('create-task-custom-close-create-deal')
		this.$root.$off('select-reserve-custom-close-create-deal')
		this.$root.$off('create-deal-cant-submit')
		this.$root.$off('customer-page-opened')
		window.removeEventListener('keydown', this.keydownHandler)
	},

	methods: {
		/**
		 * Realiza a montagem dos formulários de acordo com as configurações definidas para
		 * o cadastro de clientes/negócios
		 */
		finnally: async function (productData, stageStatus) {
			this.betaFeatures = JSON.parse(storage.get('beta_features'))
			this.options.requiredFields = await this.getRequiredFields()
			this.options.customerDealOwner = await this.getCustomerDealOwner()

			this.$root.$emit('nugget-customer-form-create-deal-modal')
			this.$root.$emit('nugget-product-form-create-deal-modal', productData)
			this.$root.$emit('nugget-stage-status-form-create-deal-modal', stageStatus)
			this.$root.$emit('nugget-historical-form-create-deal-modal')
			this.$root.$emit('nugget-responsible-form-create-deal-modal')
			this.$root.$emit('clean--create-deal-override-customer')

			this.$mx_setLoader('body', false)
		},
		handleChangeFooter(value) {
			this.onChangeFooter = value
		},
		handleFullModal(value) {
			this.onChangeModal = value
			this.onChangeFooter = false
		},
		keydownHandler(event) {
			if (event.keyCode === 27) this.closeModal()
		},
		productValidated() {
			const { real_product, unity } = this.form.product

			if (this.canSubmitProduct && this.$mx_hasValue(real_product)) {
				let product = {}

				product['product_id'] = real_product
				if (unity) product['unity_id'] = unity.id

				return product
			}

			return {}
		},
		successButton() {
			switch (this.successAction) {
				case 'redirect--client': {
					window.open(this.oldPanelLink(`vendas/negocios/${this.createdDeal.id}`))
					break
				}

				case 'redirect--make-task': {
					if (!this.createdDeal) break

					if (!this.createTaskPayload.manager_id && !this.createTaskPayload.broker_id) {
						this.$mx_alertError(
							'Não há responsável cadastrado para este cliente, não será possível cadastrar uma nova tarefa.'
						)
						break
					}

					this.$root.$emit(
						'modal-open-global--create-task',
						this.createTaskPayload,
						null,
						true
					)
					this.visible = false
					if (this.$route.name != 'customers') this.closeModal()

					break
				}

				case 'redirect--make-reserve': {
					this.$root.$emit(
						'modal-open-global--request-reserve',
						this.createdDeal,
						true,
						this.fromIFrame
					)
					this.$root.$emit('no-finalize-reserve')

					if (this.fromReserveModal) {
						this.closeModal()
						return
					}

					this.visible = false
					break
				}
			}
		},
		failedActionButton() {
			this.$mx_setLoader('modalLoading', false)
			this.$mx_setLoader('modalFailed', false)
			this.$mx_setLoader('modalSuccess', false)
			this.$mx_setLoader('message', '')
			this.$mx_setLoader('description', '')
		},
		/**
		 * Define quais serão os campos requeridos/obrigatórios do formulário,
		 * de acordo com o tipo de cadastro
		 */
		requiredFieldLoop(validationFunction) {
            let requiredObject = {}
			let requiredFields = []
			const requiredDefault = this.options.requiredFields?.required?.length
				? [...this.options.requiredFields.required]
				: []

			if (this.createProposal) {
				requiredFields = this.options?.requiredFields?.proposal?.required?.length
					? [...this.options.requiredFields.proposal.required]
					: requiredDefault

			} else if (this.fromReserveModal) {
				requiredFields = this.options?.requiredFields?.reserve?.required?.length
					? [...this.options.requiredFields.reserve.required]
					: requiredDefault

			} else {
				requiredFields = this.options?.requiredFields?.customer?.required?.length
					? [...this.options.requiredFields.customer.required]
					: []
			}

			for (const field of requiredFields) {
				requiredObject = validationFunction(field, requiredObject)
			}

            return requiredObject
        },
		closeModal() {
			if (this.$route.name == 'customers') {
				const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
				return
			}
			if (this.$route.name == 'guia') {
				const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
				return
			}
			this.onChangeModal = false
			this.clean()
			if (this.type === 'simulation') this.$root.$emit('modal-open-simulation-client')
			this.$root.$emit('modal-close-' + this.name)
			this.loader.body = true
		},
		setLink(link) {
			const event = new CustomEvent('set-new--page-legado', { detail: link })
			window.parent.document.dispatchEvent(event)
			this.$gtm.trackEvent({
				event: 'fac_button_click',
				category: 'legado-criar cliente',
				action: 'click',
				label: 'Alternar de vue para legado',
			})
			return (window.location.href = this.oldPanelLink('guia/deal'))
		},
		/**
		 * Verifica se um campo é requerido, de acordo com as configurações cadastradas
		 * e o tipo de cadastro (cliente, proposta ou reserva)
		 */
		requiredField(field) {
			if (!(this.options.requiredFields &&
				this.$mx_hasValue(this.options.requiredFields.customer))) {
				return false
			}

			let requiredFields = [...this.options.requiredFields.customer.required]
			if (this.createProposal) {
				requiredFields = this.options?.requiredFields?.proposal?.required?.length
					? [...this.options.requiredFields.proposal.required]
					: [...this.options.requiredFields.required]

			} else if (this.fromReserveModal) {
				requiredFields = this.options?.requiredFields?.reserve?.required?.length
					? [...this.options.requiredFields.reserve.required]
					: [...this.options.requiredFields.required]
			}

			if (!requiredFields || !Array.isArray(requiredFields)) return false

			return requiredFields.findIndex((f) => {
				// TODO: Esse if foi feito para quando for deal_origin_id poder tratar
				// tanto com origin quanto com deal_origin_id ate que possa ser feito 
				// essa alteração no banco
				if(field === 'deal_origin_id'){
					return f === 'origin' || f === field
				}
				return f === field
			}) !== -1
        },
		hasRequiredValue(value, tag) {
			const hv = (v) => this.$mx_hasValue(v)
			const rf = (v) => this.requiredField(v)

			return (hv(value) && rf(tag)) || !rf(tag)
		},
		/**
		 * Define quais serão as etapas a serem executadas no cadastro do cliente/negócio
		 */
		makeMenuList(list, selected = []) {
			/** Filtra todas as etapas de cadastro não selecionadas */
			if (selected.length) list = list.filter((item) => selected.includes(item.tag))

			/** Caso o usuário logado seja do tipo Corretor, remove a etapa de responsável */
			if (this.$mx_userIsBroker) {
				const index = list.findIndex((item) => item.tag == 'responsible')
				if (index >= 0) list.splice(index, 1)
			}

			/**
			 * Caso exita uma configuração de etapa e status para o cadastro de proposta,
			 * esconde-se o menu referente a seleção de etapa/status
			 */
			if (this.createProposal && this.proposalSettings?.proposal?.funnel_start?.stage_id) {
				const index = list.findIndex((item) => item.tag == 'status-stage')
				if (index >= 0) list.splice(index, 1)
			}

			return list
		},
		setMenu() {
			const i = this.menuList.findIndex((item) => item.tag == this.viewActive)
			const nextItem = this.menuList[i + 1]

			const set = (tag, prop, bool = true) => {
				this.menuList.forEach((item) => {
					if (item.tag == tag) item[prop] = bool
				})
			}

			const active = (tag) => {
				this.menuList.forEach((item) => {
					if (item.tag == tag) item.active = true
					else item.active = false
				})
			}

			const completeActual = () => {
				set(this.viewActive, 'completed')
				set(this.viewActive, 'editing', false)
			}

			const skipActual = () => {
				set(this.viewActive, 'skiped')
			}

			const activeNext = () => {
				if (nextItem) {
					this.nextForm()
					active(nextItem.tag)
					set(this.viewActive, 'editing')
				}
			}

			const editNext = () => {
				if (nextItem) set(nextItem.tag, 'editing')
			}

			return {
				set,
				skiped: (tag) => set(tag, 'skiped'),
				skipActual,
				completed: (tag) => set(tag, 'completed'),
				completeActual,
				activeNext,
				editNext,
				active,
			}
		},
		isItemMenu() {
			const find = (value, prop) => this.menuList.find((item) => value == item[prop])

			const completed = (value) => {
				const item = find(value, 'tag')
				return item ? item.completed : false
			}

			const skiped = (value) => {
				const item = find(value, 'tag')
				return item ? item.skiped : false
			}

			return {
				find,
				completed,
				skiped,
			}
		},
		handleButton() {
			const setMenu = this.setMenu()
			setMenu.completeActual()

			if (this.isDynamic) this.submitDynamic()
			else if (this.isLastStep) this.submit()
			else setMenu.activeNext()
		},
		reset() {
			this.loader = { ...defaultLoader() }
			this.loader.message = ''
			this.loader.description = ''
		},
		cleanMenu() {
			this.menuList = this.makeMenuList(defaultMenuList())
		},
		clean() {
			this.$root.$emit('create-deal-clear-duplicity-found')
			this.$root.$emit('clean--nugget-customer-form-create-deal-modal')
			this.$root.$emit('clean--nugget-product-form-create-deal-modal')
			this.$root.$emit('clean--nugget-stage-status-form-create-deal-modal')
			this.$root.$emit('clean--nugget-historical-form-create-deal-modal')
			this.$root.$emit('clean--nugget-responsible-form-create-deal-modal')
			this.$root.$emit('clean-form')

			this.createdCustomer = null
			this.createdDeal = null
			this.customerToUpdate = null
			this.customPage = []
			this.isDynamic = false
			this.dataProposal = null
			this.pageVerifications = {}
			this.proposalSettings = null

			this.cleanMenu()
			this.$store.dispatch('card/clearDataTable')
			this.$root.$emit('clean--create-deal-override-customer')
		},
		async getRequiredFields() {
			return this.getConfig('customerDuplicate', 'value_long')
		},
		async getCustomerDealOwner() {
			return this.getConfig('customerDealOwner', 'value_long')
		},
		async getConfig(config, type = 'value') {
			const request = (await configuration.getConfig(config)).data
			return request[type]
		},
		makeModalMessage(message, description = '', action = '') {
			return { message, description, action }
		},
		async captureDealInfo() {
			if (!this.openSearchAllowed || !this.disableResponsible) return

			try {
				const { data } = await deal.activeFunnelDealById(this.customerToUpdate.id_customer)
				const first = data[0]

				if (first && first['owners']) {
					this.customerToUpdate['owners']['team_id'] = first['owners']['team_id']
					this.customerToUpdate['owners']['broker_id'] = first['owners']['broker_id']
					this.customerToUpdate['owners']['manager_id'] = first['owners']['manager_id']
				}
			} catch (error) {
				console.log(error)
				if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
			}
		},
		/**
		 * Realiza as requisições necessárias para cadastrar um cliente/negócio,
		 * juntamente com o Registro de Atendimento
		 */
		submitQueue: async function () {
			let customer = null
			let customer_id = null
			const origin_id = this.form.customer.origin_id
			let modalMessage = 'Falha no cadatro do cliente/negócio'

			/**
		 	* Problema: O country_code e o phone/mobile, vem de juntos mesma na propriedade phone/mobile 
		 	* Solução: Desestruturar o número de telefone para separar o código do país do restante do número
			  para enviar separadamente
		 	*/
			const fields = ["phone", "mobile"];

			fields.forEach(field => {
			    let match = this.customerValidated[field]?.match(/^\+(\d{1,3})\s(.*)$/);

			    this.customerValidated[`country_code_${field}`] = match ? Number(match[1]) : null;
			    this.customerValidated[field] = match ? match[2].replace(/(?!^\+)[^\d]/g, '') : null;
			});

			if (this.customerToUpdate) {
				customer_id = this.customerToUpdate.id_customer
			} else {
				customer = { 
					...this.customerValidated,
				}	
			}

			// Criação do objeto deal.
			const dealParams = {
				customer_id,
				origin_id,
				...this.productValidated(),
				...this.responsibleValidated,
				...this.stageStatusValidated,
				cost: this.type === 'simulation' ? this.proposedValue : 0,
			}

			if (!dealParams.customer_id) delete dealParams.customer_id
			if (!dealParams.origin_id) delete dealParams.origin_id
			if (!dealParams.unity_id) delete dealParams.unity_id

			try {
				// Verifica se já foi criado o Deal
				if (!this.createdDeal) {
					// Altera a etapa e status configuradas para proposta caso existam
					if (this.createProposal && this.proposalSettings?.proposal?.funnel_start?.stage_id) {
						dealParams.funnel_stage_id = this.proposalSettings.proposal.funnel_start.stage_id
						dealParams.funnel_stage_status_id = this.proposalSettings.proposal.funnel_start.status_id
					}

					/**
					 * Envia os dados do negócio (e cliente se for cadastrar) e o cadastra no banco
					 * de dados
					 */
					let params = { deal: dealParams }
					if (!customer_id) params = { ...params, customer }
					this.loader.message = 'Salvando cliente...'
					modalMessage = 'Erro ao criar o cliente!'
					const response = await deal.createV2('', params)
					this.createdDeal = { ...response.data.data }
					this.createdCustomer = { ...response.data.data.customer }
					const data = {
						step5: { deal: { ...this.createdDeal }, deal_id: this.createdDeal.id },
					}
					storage.setLegacy(`guide_proposalNew_${this.user.id}`, JSON.stringify(data))
					this.customerId = this.createdDeal.customer_id
					// Emite o evento indicando que o castrado do negócio terminou
					this.$root.$emit('modal-result-' + this.name, this.createdDeal)
				}

				const { id: deal_id } = this.createdDeal
				const { message } = this.form.historical

				// Cadastra o Registro de Atendimento
				if (
					this.canSubmitHistorical &&
					this.$mx_hasValue(message) &&
					this.$mx_hasValue(deal_id)
				) {
					this.loader.message = 'Enviando Registro de Atendimento...'
					modalMessage = 'Erro ao registrar atendimento!'
					await dealHistorical.create('', { ...this.form.historical, deal_id })
				}

			} catch (error) {
				console.log(error)
				if (error.data && error.data.msg) {
					throw this.makeModalMessage(modalMessage, error.data.msg, 'product')

				} else {
					throw this.makeModalMessage(modalMessage, error, 'product')
				}
			}
		},
		/**
		 * Submete os dados dos campos dinâmicos
		 */
		async submitDynamic(submitWithNoField = false) {
			const dynamicForm = this.dataProposal.find((form) => form.id === this.idDynamic)
			const hasFile = !!dynamicForm?.fields?.filter((field) => field.type === 'file').length

			if (!hasFile) {
				let form = {}
				for (const data in this.formDynamic[this.idDynamic]) {
					if (typeof this.formDynamic[this.idDynamic][data] === 'object' && this.formDynamic[this.idDynamic][data] !== null) {
						form[`field_value[${data}]`] = this.formDynamic[this.idDynamic][data].value
					} else {
						form[`field_value[${data}]`] = this.formDynamic[this.idDynamic][data]
					}
				}
				this.saveDynamic(
					this.idDeals || this.idOverride || this.idChosen,
					this.idDynamic,
					qs.stringify({ ...form })
				)
			}

			const setMenu = this.setMenu()
			setMenu.completeActual()

			if(submitWithNoField && (this.idDeals || this.idOverride || this.idChosen)) {
				this.$router.push(`/vendas/procedimentos/${this.customerId}/proposta`)
				this.loader.page = true
			}

			if (this.isLastStep && (this.idDeals || this.idOverride || this.idChosen)) {
				this.$router.push(`/vendas/procedimentos/${this.customerId}/proposta`)
				this.loader.page = true
			} else {
				setMenu.activeNext()
			}
		},
		async submit() {
			if (!this.customerValidators.all) return

			try {
				if (this.createProposal) {
					this.loader.body = true
					await this.submitQueue()
					let body =
						this.proposalSettings &&
						this.proposalSettings.proposal &&
						this.proposalSettings.proposal.funnel_start.stage_id
							? {
									funnel_stage_id:
										this.proposalSettings.proposal.funnel_start.stage_id,
							  }
							: null
					this.idDeals =
						this.createdDeal && this.createdDeal.id ? this.createdDeal.id : null
					if (body && this.idDeals && !this.isDynamic) {
						body['funnel_stage_status_id'] =
							this.proposalSettings.proposal.funnel_start.status_id &&
							this.proposalSettings.proposal.funnel_start.status_id != ''
								? this.proposalSettings.proposal.funnel_start.status_id
								: null
						if (
							(this.createdDeal.funnel_stage_id &&
								this.createdDeal.funnel_stage_id == body.funnel_stage_id &&
								this.createdDeal.funnel_stage_status_id &&
								this.createdDeal.funnel_stage_status_id ==
									body['funnel_stage_status_id']) ||
							(this.createdDeal.funnel_stage_id &&
								this.createdDeal.funnel_stage_id == body.funnel_stage_id) ||
							(this.createdDeal.funnel_stage_status_id &&
								this.createdDeal.funnel_stage_status_id ==
									body['funnel_stage_status_id'])
						) {
							await this.getProposalGroup().then((value) => {
								this.dataProposal = value
							})
							this.proposalMenu(this.dataProposal)
							this.isDynamic = true
							this.loader.body = false
						} else {
							const { data } = await funnel.updateV2(
								'deal/',
								`${this.idDeals}/move`,
								body
							)
							if (data.msg && data.status !== 'success') throw new Error(data.msg)
							this.dataProposal = data.data.groups
							this.proposalMenu(this.dataProposal)
							this.isDynamic = true
							this.loader.body = false
							this.$toastr.s(data.msg)
						}
					}
					let loaderDescription = 'O que deseja fazer agora?'

					if (this.type === 'simulation') {
						this.$store.dispatch('simulation/setCustomer', this.createdCustomer)
						this.$store.dispatch('simulation/setCustomerDeal', this.createdDeal)
						this.$store.dispatch(
							'simulation/setSimulationOwner',
							this.createdDeal.owners
						)
						loaderDescription = 'O cadastro do cliente foi finalizado.'
					}

					setTimeout(() => {
						this.$mx_setLoader('message', 'Cliente criado com sucesso!')
						this.$mx_setLoader('description', loaderDescription)
						this.$mx_setLoader('modalSuccess', true)
					}, 500)

				} else {
					this.$mx_setLoader('modalLoading', true)
					this.$mx_setLoader('modalFailed', false)
					this.$mx_setLoader('message', '')
					this.$mx_setLoader('description', '')

					await this.submitQueue()

					let loaderDescription = 'O que deseja fazer agora?'

					if (this.type === 'simulation') {
						this.$store.dispatch('simulation/setCustomer', this.createdCustomer)
						this.$store.dispatch('simulation/setCustomerDeal', this.createdDeal)
						this.$store.dispatch(
							'simulation/setSimulationOwner',
							this.createdDeal.owners
						)
						loaderDescription = 'O cadastro do cliente foi finalizado.'
					}

					setTimeout(() => {
						this.$mx_setLoader('message', 'Cliente criado com sucesso!')
						this.$mx_setLoader('description', loaderDescription)
						this.$mx_setLoader('modalSuccess', true)
					}, 500)
				}
			} catch (error) {
				if(this.createProposal) this.$toastr.e(error)
				this.$mx_setLoader('modalFailed', true)
				this.$mx_setLoader('message', error.message)
				this.$mx_setLoader('description', error.description)
				if (error.action) this.setMenu().active(error.action)
			}
			this.onChangeModal = true
		},
		/**
		 * Salva os dados vindos dos campos dinâmicos
		 */
		saveDynamic(dealId, groupId, data, dataTable) {
			if (dealId && groupId) {
				funnel
					.updateDynamic(dealId, groupId, data)
					.then((response) => {
						this.$root.$emit('cancel-load-dynamic', { ...response.data })

						if (dataTable) {
							this.$root.$emit('create-deal-modal-dynamic-saved', { ...response.data })
							let addDataTable = {id: groupId, dataTable: dataTable}
							this.$store.dispatch('card/addDataToDataTable', addDataTable)
						}
					})
					.catch((error) => {
						if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
						console.log(error)
					})
			}
		},
		getProposalGroup,
		/**
		 * Monta o menu e a página dos campos dinâmicos
		 */
		proposalMenu: async function (data) {
			let item = []
			let page = []

			this.productInformakon = (
				this.form?.product?.product_object?.infos?.informakon &&
				(
					(typeof this.form.product.product_object.infos.informakon === 'object' &&
					this.form.product.product_object.infos.informakon.v === 'true') ||
					this.form.product.product_object.infos.informakon === 'true'
				)
			) ? true : false

			data.map((value) => {
				if (value.fields && value.fields.length && value.fields.length > 0) {
					item.push({
					id: '',
					meta: value.id,
					name: value.name,
					tag: value.name,
					active: false,
					completed: false,
					skiped: false,
					editing: false,
					})

				}

				this.formDynamic[value.id] = {}
				value.fields.map((has) => {
				this.formDynamic[value.id][has.id] = ''
				has.observation = ''
				})

				page.push({
				id: value.id,
				tag: value.name,
				fields: value.fields,
				repeater: value.repeater
				})
			})

			this.resetNonDynamicMenuItems()

			this.updateMenuList([
				{
				id: 1,
				name: 'Cliente Cadastrado',
				tag: 'customer-cadastrado',
				active: false,
				completed: false,
				skiped: false,
				editing: false,
				},
				...item,
			])
			
	
			page = page.map((fieldGroup) => {
				fieldGroup.required = {}

				for (const field of fieldGroup.fields) {
					fieldGroup.required[field.id] = field.required
				}

				return fieldGroup
			})
			
			let isInformakon = this.productInformakon ;
			let proposalFields = JSON.parse(JSON.stringify(this.proposalSettings.fields))
			const { filteredFields, hasConfigurationFields, hasRequiredFields } = this.filterFields(page, proposalFields, isInformakon)
			this.menuList = this.menuList.filter(menu => {
				if (menu.tag === 'customer-cadastrado') return true;
				if (filteredFields.find(field => field.tag === menu.name)) return true;
			});
			if( !hasConfigurationFields && !hasRequiredFields ) this.submitDynamic(true);
			this.customPage = filteredFields
			this.handleButton()
		},
		filterFields(pattern, fields, isInformakon = false) {
			let hasConfigurationFields = false;
			let hasRequiredFields = false;

			const filteredFields = pattern.map(pageItem => {
				const matchingGroup = fields[String(pageItem.id)];

				if (matchingGroup) {
					const updatedFields = pageItem.fields.filter(field => {
						const isMatchingField = matchingGroup.includes(String(field.id));
						const isRequired = Boolean(field.required);
						const hasInformakon = field.options?.informakon;
						const isInformakonEmpty = (Array.isArray(hasInformakon) && hasInformakon.length === 0) || 
							(typeof hasInformakon === "object" && hasInformakon !== null && Object.keys(hasInformakon).length === 0);

						if (isMatchingField) hasConfigurationFields = true;
						if (isRequired) hasRequiredFields = true;

						if (isInformakon && !isMatchingField && !isRequired && !isInformakonEmpty) {
							return false;
						}

						return isMatchingField || isRequired;
					});

					if (updatedFields.length === 0) return null;

					return {
						...pageItem,
						fields: updatedFields
					};
				}
				return null;
			}).filter(Boolean);

			return { filteredFields, hasConfigurationFields, hasRequiredFields };
		},
		/**
		 * Verifica o formulário vindo dos campos dinâmicos
		 */
		canSubmitDynamic(verification, form) {
			this.formDynamic[this.idDynamic] = form
			this.verificationDynamic = verification
			this.$set(this.pageVerifications, this.idDynamic, verification) // Atualiza o estado da verificação da página atual
			const allPreviousVerificationsTrue = Object.values(this.pageVerifications).every(
				(value) => value === true
			)
			this.isTheLastStep = allPreviousVerificationsTrue // Atualiza o estado do botão isTheLastStep
		},
		cpfValidate(cpf, typePerson) {
			return this.$mx_hasValue(cpf)
				? this.$mx_validateCPF(cpf)
				: this.hrv(cpf, 'cpf') && typePerson === 'Pessoa Fisica'
		},
		hrv(value, tag) {
			return this.hasRequiredValue(value, tag)
		},
		cnpjValidate(cnpj, typePerson) {
			return this.$mx_hasValue(cnpj)
				? this.$mx_validateCNPJ(cnpj)
				: this.hrv(cnpj, 'cpf') && typePerson === 'Pessoa Juridica'
		},
		nameValidate(name) {
			return this.$mx_hasValue(name) ? name.length > 2 : this.hrv(name, 'name')
		},
		emailValidate(email) {
			return this.$mx_hasValue(email)
				? this.$mx_validateEmail(email)
				: this.hrv(email, 'email')
		},
		phoneValidate(phone, tag) {
			return this.$mx_hasValue(phone) ? this.$mx_validatePhone(phone, tag, this.customerRequiredField[tag]) : this.hrv(phone, tag)
		},
		openModalFinish() {
			this.$root.$emit('modal-open-new-create-proposal')
		},
		/**
		 * Verifica formulário vindo dos campos dinâmicos
		 */
		nextForm(id) {
			return this.formDynamic[id]
		},
		/**
		 * Organiza o menu para que depois do cliente ser cadastrado, apareça apenas no menu lateral "Cliente Cadastrado"
		 */
		updateMenuList(items) {
			this.menuList = [...items, ...this.menuList.slice(items.length)]
		},
		/**
		 * Quando o cliente já existe e tem um único negócio, porém não está na etapa configurada, ele faz o move para a etapa correta
		 * e continua o preenchimento dos campos pelo modal de proposta
		 */
		async jumpStep() {
			this.customerId = this.customerToUpdate.customer_id
			const data = {
				step5: {
					deal: {
						id: this.customerToUpdate.id_deal,
						...this.customerToUpdate
					},
					deal_id: this.customerToUpdate.id_deal
				}
			}
			// Foi necessário esse delete, pois o data está em looping infinito
			delete data.step5.deal.data
			storage.setLegacy(`guide_proposalNew_${this.user.id}`, JSON.stringify(data))
			try {
				this.proposalSettings = await this.getConfig('proposalSettings', 'value_long')
				let body_start = this.proposalSettings &&
					this.proposalSettings.proposal &&
					this.proposalSettings.proposal.funnel_start.stage_id
						? { funnel_stage_id: this.proposalSettings.proposal.funnel_start.stage_id }
						: null
				body_start['funnel_stage_status_id'] =
					this.proposalSettings.proposal.funnel_start.status_id &&
					this.proposalSettings.proposal.funnel_start.status_id != ''
						? this.proposalSettings.proposal.funnel_start.status_id
						: null
				let body_end =
					this.proposalSettings &&
					this.proposalSettings.proposal &&
					this.proposalSettings.proposal.funnel_end.stage_id
						? { funnel_stage_id: this.proposalSettings.proposal.funnel_end.stage_id }
						: null
				body_end['funnel_stage_status_id'] =
					this.proposalSettings.proposal.funnel_end.status_id &&
					this.proposalSettings.proposal.funnel_end.status_id != ''
						? this.proposalSettings.proposal.funnel_end.status_id
						: null
				if (
					this.stageOverride &&
					this.stageOverride == body_end.funnel_stage_id &&
					this.statusOverride &&
					this.statusOverride == body_end['funnel_stage_status_id']
				) {
					const customerURL = this.$mx_oldPanelLink('vendas/negocios/' + this.idOverride)
					window.location.href = customerURL
					this.loader.body = true
				} else if((this.stageOverride &&
					this.stageOverride == body_start.funnel_stage_id &&
					this.statusOverride &&
					this.statusOverride == body_start['funnel_stage_status_id']) ||
					(this.stageOverride &&
					this.stageOverride == body_start.funnel_stage_id && this.statusOverride === null)) {
					this.loader.body = true
					await this.getProposalGroup().then((value) => {
								this.dataProposal = value
							})
							this.proposalMenu(this.dataProposal)
							this.isDynamic = true
							this.loader.body = false
					this.$toastr.s(data.msg)
				} else {
					const { data } = await funnel.updateV2(
								'deal/',
								`${this.idOverride}/move`,
								body_start
							)
							if (data.msg && data.status !== 'success') throw new Error(data.msg)
							this.dataProposal = data.data.groups
							this.proposalMenu(this.dataProposal)
							this.isDynamic = true
							this.loader.body = false
							this.$toastr.s(data.msg)
				}
			} catch (error) {
				this.$toastr.e(error)
			}
		},
		/**
		 * Quando o cliente já existe e tem mais de um negócio, porém não está na etapa configurada, ele faz o move para a etapa correta
		 * e continua o preenchimento dos campos pelo modal de proposta
		 */
		async jumpStepChosen() {
			this.customerId = this.customerToUpdate.customer_id
			const data = {
				step5: {
					deal: {
						id: this.customerToUpdate.id_deal,
						...this.customerToUpdate
					},
					deal_id: this.customerToUpdate.id_deal
				}
			}
			//Foi necessário esse delete, pois o data está em looping infinito
			delete data.step5.deal.data
			storage.setLegacy(`guide_proposalNew_${this.user.id}`, JSON.stringify(data))
			try {
				this.proposalSettings = await this.getConfig('proposalSettings', 'value_long')
				let body_start = this.proposalSettings &&
					this.proposalSettings.proposal &&
					this.proposalSettings.proposal.funnel_start.stage_id
						? { funnel_stage_id: this.proposalSettings.proposal.funnel_start.stage_id }
						: null
				body_start['funnel_stage_status_id'] =
					this.proposalSettings.proposal.funnel_start.status_id &&
					this.proposalSettings.proposal.funnel_start.status_id != ''
						? this.proposalSettings.proposal.funnel_start.status_id
						: null
				let body_end =
					this.proposalSettings &&
					this.proposalSettings.proposal &&
					this.proposalSettings.proposal.funnel_end.stage_id
						? { funnel_stage_id: this.proposalSettings.proposal.funnel_end.stage_id }
						: null
				body_end['funnel_stage_status_id'] =
					this.proposalSettings.proposal.funnel_end.status_id &&
					this.proposalSettings.proposal.funnel_end.status_id != ''
						? this.proposalSettings.proposal.funnel_end.status_id
						: null
				if (
					this.stageChosen &&
					this.stageChosen == body_end.funnel_stage_id &&
					this.statusChosen &&
					this.statusChosen == body_end['funnel_stage_status_id']
				) {
					const customerURL = this.$mx_oldPanelLink('vendas/negocios/' + this.idChosen)
					window.location.href = customerURL
					this.loader.body = true
				} else if((this.stageChosen &&
					this.stageChosen == body_start.funnel_stage_id &&
					this.statusChosen &&
					this.statusChosen == body_start['funnel_stage_status_id']) || (this.stageChosen &&
					this.stageChosen == body_start.funnel_stage_id &&
					this.statusChosen === null)) {
					this.loader.body = true
					await this.getProposalGroup().then((value) => {
								this.dataProposal = value
							})
							this.proposalMenu(this.dataProposal)
							this.isDynamic = true
							this.loader.body = false
					this.$toastr.s(data.msg)
				} else {
					const { data } = await funnel.updateV2(
								'deal/',
								`${this.idChosen}/move`,
								body_start
							)
							if (data.msg && data.status !== 'success') throw new Error(data.msg)
							this.dataProposal = data.data.groups
							this.proposalMenu(this.dataProposal)
							this.isDynamic = true
							this.loader.body = false
							this.$toastr.s(data.msg)
				}
			} catch (error) {
				this.$toastr.e(error)
			}
		},
		/**
		 * Reseta os itens do menu, para que não fique marcado como "completed = true" caso ele exista também
		 * nos campos dinâmicos
		 *
		 */
		resetNonDynamicMenuItems() {
			const nonDynamicItems = [
				{
					id: 2,
					name: 'Empreendimento de Interesse',
					tag: 'product',
				},
				{
					id: 3,
					name: 'Etapa e Status',
					tag: 'status-stage',
				},
				{
					id: 4,
					name: 'Responsável',
					tag: 'responsible',
				},
			]

			nonDynamicItems.forEach((item) => {
				const menuItem = this.menuList.find((menuItem) => menuItem.id === item.id)
				if (menuItem) {
					menuItem.active = false
					menuItem.completed = false
					menuItem.skiped = false
					menuItem.editing = false
				}
			})
		},
		updateIdDynamic(active) {
			this.idDynamic = active.meta || null
		},
		/**
		 * Trata o evento de quando a impressão do comprovante de credenciamento é requerida
		 */
		printHandler() {
			this.loader.print = true
			// Pega todas as tags style para adicionar as classes CSS no modal
			let stylesHtml = ''
			for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
				stylesHtml += node.outerHTML
			}
			stylesHtml += `
                    <style type="text/css">
                        @media print {
                            @page {
                                size: landscape !important
                                margin: 0px
                            }
                        }
                    </style>
                `

			const printWindow = window.open('', 'PRINT', 'height=600,width=400')
			printWindow.document.write(`
                    <html>
                        <head>
                            ${stylesHtml}
                            <title>Imprimir Comprovante</title>
                        </head>
                        <body>
                            ${document.getElementById('accreditation_voucher').innerHTML}
                        </body>
                    </html>
                `)

			printWindow.document.close() // Necessary for IE >= 10
			printWindow.focus() // Necessary for IE >= 10*/

			// Cadastra o checkin para o controle de credenciamento
			const params = {
				model: 'Deal_Main',
				id: this.createdDeal.id,
				points_id: this.definitions.launchday_point_id,
			}
			launchDay
				.create('checkin', params)
				.then((response) => {
					this.$toastr.s(response.data.msg)
					this.loader.print = false
					printWindow.print()
					printWindow.close()
				})
				.catch((error) => {
					if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					console.log(error)
				})
		},
		overrideCustomer(customer) {
			this.$root.$emit('select-deal-override-customer', customer)
			this.$refs.clean.cleanSetDeal()
		},
		comeBack() {
			this.customerToUpdate = null
			this.$refs.clean.clearDuplicityFound()
			this.$refs.clean.cleanSetDeal()
		},
		/** 
		 * Funçao usada no root open modal
		 */
		parseParams(params) {
			if (params && typeof params === 'object') {
				this.createProposal = params.action === 'createProposal';
				this.type = params.type || 'default';
			} else {
				this.createProposal = params && params === 'createProposal';
				this.type = params?.type || 'default';
			}
		},
		/** 
		 * Funçao usada no root open modal, trata os diferentes tipos
		 */
		async handleType(params) {
			let productData = null;
			let stageStatus = null;

			switch (this.type) {
				case 'default':
					this.handleDefaultType(params);
					productData = this.getProductDataForDefaultType();
					break;
				case 'simulation':
					productData = this.getProductDataForSimulationType();
					stageStatus = await this.getStageStatusForSimulationType();
					break;
				case 'launchday':
					({ productData, stageStatus } = this.handleLaunchDayType(params));
					break;
				default:
					this.handleDefaultType(params);
					productData = this.getProductDataForDefaultType();
					break;
			}

			return { productData, stageStatus };
		},
		/** 
		 * Funçao usada no root open modal
		 */
		handleDefaultType(params) {
			this.menuList = this.makeMenuList(defaultMenuList());
		},
		getProductDataForDefaultType() {
			if (this.fromReserveModal && this.product) {
				return {
					product_id: this.product.id,
					unity_id: this.unity ? this.unity.id : null,
				};
			}
			return null;
		},
		/** 
		 * Funçao usada no root open modal
		 */
		getProductDataForSimulationType() {
			if (this.product) {
				return {
					product_id: this.product.id,
					unity_id: this.unity ? this.unity.id : null,
				};
			}
			return null;
		},
		/** 
		 * Funçao usada no root open modal, ajustas os parametros 
		 * e seta a propriedades necessárias
		 */
		async getStageStatusForSimulationType() {
			const config = JSON.parse(storage.get('proposal_settings'));
			if (config && config.simulation && config.simulation.funnel_start) {
				this.menuList = this.makeMenuList(defaultMenuList());
				return {
					funnel_stage_id: config.simulation.funnel_start.stage_id
						? parseInt(config.simulation.funnel_start.stage_id)
						: null,
					funnel_stage_status_id: config.simulation.funnel_start.status_id
						? parseInt(config.simulation.funnel_start.status_id)
						: null,
				};
			}
			return null;
		},
		/** 
		 * Funçao usada no root open modal
		 */
		handleLaunchDayType(params) {
			const productData = { product_id: params.product_id };
			const stageStatus = {
				funnel_stage_id: params.stage ? parseInt(params.stage) : null,
				funnel_stage_status_id: params.status ? parseInt(params.status) : null,
			};

			this.$root.$emit('nugget-stage-status-form-create-deal-modal', stageStatus);

			this.menuList = this.makeMenuList(defaultMenuList(), ['customer', 'responsible']);

			return { productData, stageStatus };
		},
		/** 
		 * Funçao usada no root open modal, Emite eventos para inicializar componentes
		 */
		emitInitializationEvents(productData, stageStatus) {
			this.$root.$emit('nugget-customer-form-create-deal-modal');
			this.$root.$emit('nugget-product-form-create-deal-modal', productData);
			this.$root.$emit('nugget-stage-status-form-create-deal-modal', stageStatus);
			this.$root.$emit('nugget-historical-form-create-deal-modal');
			this.$root.$emit('nugget-responsible-form-create-deal-modal');
			this.$root.$emit('nugget-negotiation-form-create-deal-modal');
			this.$root.$emit('clean--create-deal-override-customer');
		},
	},
}
</script>

<style lang="stylus" scoped>
@import './styles.styl';
</style>
